import type {
  Invitation,
  InvitationStatus,
  CreateInvitationCommand,
  AcceptInvitationCommand,
  AcceptedInvitation,
} from '@/domain/model/Invitation';
import type { InvitationGateway } from '@/application/port/out/InvitationGateway';
import type {
  ListInvitationsUseCase,
  CreateInvitationUseCase,
  ResendInvitationUseCase,
  RevokeInvitationUseCase,
  AcceptInvitationUseCase,
} from '@/application/port/in/InvitationUseCase';

export class ListInvitations implements ListInvitationsUseCase {
  constructor(private readonly g: InvitationGateway) {}
  execute(status?: InvitationStatus): Promise<Invitation[]> {
    return this.g.list(status);
  }
}
export class CreateInvitation implements CreateInvitationUseCase {
  constructor(private readonly g: InvitationGateway) {}
  execute(cmd: CreateInvitationCommand): Promise<Invitation> {
    return this.g.create(cmd);
  }
}
export class ResendInvitation implements ResendInvitationUseCase {
  constructor(private readonly g: InvitationGateway) {}
  execute(id: string): Promise<Invitation> {
    return this.g.resend(id);
  }
}
export class RevokeInvitation implements RevokeInvitationUseCase {
  constructor(private readonly g: InvitationGateway) {}
  execute(id: string): Promise<void> {
    return this.g.revoke(id);
  }
}

export class AcceptInvitation implements AcceptInvitationUseCase {
  constructor(private readonly gateway: InvitationGateway) {}
  execute(command: AcceptInvitationCommand): Promise<AcceptedInvitation> {
    return this.gateway.accept({ ...command, nomeCompleto: command.nomeCompleto.trim() });
  }
}
